
import { showErrorAlertDialog } from '@/features/common/helpers';
import {
  Component, PropSync, Mixins,
} from 'vue-property-decorator';
import legacyMixin from '@/features/common/mixins/legacyMixin';
import FeatureFlagMixin from '@/features/common/mixins/featureFlagMixin';
import { CarrierCodeType } from '@/features/shipment/types';
import { GlobalResponseType } from '@/features/common/types';
import { registerCPCMerchant } from '../services/merchantRegistration.services';
import { getAllAvailableServiceAccounts } from '../services/carrierAccounts.services';
import { AvailableAccountsType } from '../types';
import { isRegisteredThroughMerchant, isFedexRegistration } from '../helpers';

@Component
export default class AddUserModal extends Mixins(legacyMixin, FeatureFlagMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private carrierAccounts: AvailableAccountsType[] = [];

  protected featureKeysToLoad = ['useFedexNewRegistration'];

  created(): void {
    this.fetchAvailableAccounts();
  }

  private async continueToAddCarrierAccount(carrierCode: keyof typeof CarrierCodeType) {
    this.syncedShow = false;

    if (isFedexRegistration(carrierCode)
      && !this.isLegacyFeatures
      && this.featureFlags.useFedexNewRegistration) {
      this.$router.push({ name: 'carrier-accounts-fedex' });
      return;
    }

    if (isRegisteredThroughMerchant(carrierCode) && !this.isLegacyFeatures) {
      this.getMerchantRegistrationUrl(carrierCode);
      return;
    }

    this.$router.push({
      name: 'carrier-accounts-add',
      query: {
        carrierCode,
        legacy: this.isLegacyFeatures ? 'true' : undefined,
      },
    });
  }

  private async fetchAvailableAccounts() {
    const accounts = await getAllAvailableServiceAccounts();

    if (accounts && accounts.successful && accounts.data && accounts.data.length) {
      this.carrierAccounts = accounts.data;
    }
  }

  private async getMerchantRegistrationUrl(carrierCode: keyof typeof CarrierCodeType) {
    this.$store.commit('setLoading', true);

    let response: { returnUrl?: string | undefined } & GlobalResponseType = {
      successful: false,
      redirectUrl: '',
      errorMessage: '',
    };

    let info = {
      message: '',
      banner: '',
    };

    if (carrierCode === 'Canadapost') {
      response = await registerCPCMerchant();
      info = {
        message: this.$t('carrierAccounts.merchantRegistration.body', {
          carrier: carrierCode,
        }) as string,
        banner: 'MerchantRedirectCPC',
      };
    }

    if (response.successful && response.returnUrl) {
      this.$emit('showMerchantRedirect', {
        redirectUrl: response.returnUrl,
        message: info.message,
        banner: info.banner,
      });
      this.syncedShow = false;
    } else {
      showErrorAlertDialog(response.errorMessage);
    }

    this.$store.commit('setLoading', false);
  }
}
